import React, {useState} from 'react'
import cuViewTV from './icons/CuViewTV.svg'
import { useNavigate, useLocation } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { logout } from '../actions/AuthActions';
import IconMenu from './icons/IconMenu.svg'
import IconLeave from './icons/IconLeave.svg'
import IconClose from './icons/IconClose.svg'
import BackArrow from './icons/BackArrow.svg'


function Header(props) {

    const [profileActive, setProfileActive] = useState(false)
    const { user } = useSelector(state=>state.user)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const logoutHandler = () =>{
        dispatch(logout())
        navigate('/')
    }


    const backHandler = () => {
        navigate(-1)
    }

  return (

        <div className="w-100 bg-primary d-flex justify-content-center" id = "header"
            style={{ position:"fixed", top:"0", zIndex:"1100"}}
        >
            <div className = "col-12 col-lg-10 py-2 mb-lg-0 px-3 px-lg-0 py-lg-4 d-flex justify-content-between align-items-center">
                <div className='d-block d-lg-none'>
                    <img
                        className='header_icons'
                        role="button"
                        src={IconMenu}  alt="Menu"
                        onClick={()=>props.setMobileMenuOpen(!props.mobileMenuOpen)}
                        />
                </div>
                <div className=''>
                    <img
                        className='d-none d-lg-inline '
                        role="button"
                        src={BackArrow}  alt="back arrow"
                        style={{height:"2rem", marginRight:"1rem"}}
                        onClick={()=>backHandler()}
                    />
                    <img role="button"
                    className='header-logo'
                        src={cuViewTV}  alt="CuviewTV TV logo"
                        onClick={()=>navigate('/')}/>
                </div>

                {
                    user ?
                    <div className='d-block d-lg-none'
                        onClick={()=>setProfileActive(!profileActive)}
                        >
                            <img
                                className='header_icons'
                                src={IconLeave}
                                alt="logout icon"
                                role='button'
                                onClick={logoutHandler}
                            />
                    </div> :
                    <div className = 'd-lg-none text-info text-underline fs-2 fw-bold d-flex align-items-center text-decoration-underline'
                        role = 'button'
                        onClick={()=>{navigate('/login')}}
                    >Login</div>
                }

                <div className='col-3 d-none d-lg-flex justify-content-end position-relative'>
                    {
                        user && user.first_name && user.last_name ?
                        <div className='d-none col-4 d-lg-flex flex-column flex-md-row h-100 justify-content-center justify-content-md-start justify-content-lg-center align-items-center'
                            onClick={()=>setProfileActive(!profileActive)} >
                                <div
                                    className='bg-yellow border p-2 border-yellow rounded-circle d-flex justify-content-center align-items-center'
                                    >
                                    <div
                                        alt="person icon"
                                        role='button'
                                        className = "fw-bold text-primary text-center overflow-hidden text-nowrap"
                                        >{user.first_name[0].toUpperCase() + user.last_name[0].toUpperCase()}</div>
                                    </div>
                        </div> :
                        <div className = 'text-info text-underline fs-2 fw-bold d-flex align-items-center text-decoration-underline'
                            role = 'button'
                            onClick={()=>{navigate('/login')}}
                        >Login</div>
                    }

                    {
                        profileActive &&
                        <div
                            className = "col-4 px-1 px-lg-2 py-1 mt-5 ms-0 ms-lg-5 bg-white position-absolute text-center rounded"
                            style={{zIndex:"999"}}
                            onMouseLeave = {()=> setProfileActive(false)}>
                            <div className = "px-3 py-2 w-100 rounded color-secondary profile-menu-object"
                                onClick = { logoutHandler } >Logout
                            </div>
                            {
                            user && user.is_staff ?
                            <div className = "px-1 fs-5 fs-md-6 py-2 w-100 text-nowrap rounded color-secondary profile-menu-object"
                                onClick={()=>navigate(`/main`)}
                                >Admin Page
                            </div> : ""
                            }
                        </div>
                    }
                </div>

            </div>
        </div>

    // </div>
  );
}

export default Header;

